import React from 'react';
import { FaThumbtack } from 'react-icons/fa';
import { formatPinnedUntilLongDate } from './pinnedContent';
import './PinnedHeroCard.css';

export function PinnedHeroSection({ title, count, ariaLabel, children }) {
  return (
    <section className="pinned-hero-section" aria-label={ariaLabel}>
      <header className="pinned-hero-section__header">
        <FaThumbtack className="pinned-hero-section__icon" aria-hidden="true" />
        <h2 className="pinned-hero-section__title">{title}</h2>
        <span className="pinned-hero-section__count">{count}</span>
      </header>
      <div className="pinned-hero-cards">{children}</div>
    </section>
  );
}

export default function PinnedHeroCard({
  pinnedUntil,
  thumbnailUrl,
  placeholderIcon: PlaceholderIcon,
  title,
  badges,
  extra,
  meta,
  actions,
  actionsLayout = 'flex',
  showActionsArea = false,
  onClick,
  isUnread = false,
  className = '',
  inactive = false,
}) {
  const pinnedUntilDate = formatPinnedUntilLongDate(pinnedUntil);
  const shouldRenderActions = showActionsArea || actions != null;
  const actionsClassName = [
    'pinned-hero-card__actions',
    actionsLayout === 'grid-3' && 'pinned-hero-card__actions--grid-3',
    actionsLayout === 'reserved' && 'pinned-hero-card__actions--reserved',
  ].filter(Boolean).join(' ');

  return (
    <article
      className={[
        'pinned-hero-card',
        isUnread && 'pinned-hero-card--unread',
        inactive && 'pinned-hero-card--inactive',
        className,
      ].filter(Boolean).join(' ')}
      onClick={onClick}
    >
      <div className="pinned-hero-card__banner">
        <div className="pinned-hero-card__banner-main">
          <FaThumbtack className="pinned-hero-card__pin-icon" aria-hidden="true" />
          <span className="pinned-hero-card__pin-copy">
            Pripeto do <strong>{pinnedUntilDate}</strong>
          </span>
        </div>
      </div>

      <div className="pinned-hero-card__media">
        {isUnread && (
          <span className="pinned-hero-card__unread" title="Neprebrano" aria-label="Neprebrano">
            <span className="platform-unread-dot" />
          </span>
        )}
        {thumbnailUrl ? (
          <img src={thumbnailUrl} alt="" loading="lazy" />
        ) : (
          <div className="pinned-hero-card__media-placeholder" aria-hidden="true">
            {PlaceholderIcon ? <PlaceholderIcon /> : null}
          </div>
        )}
      </div>

      <div className="pinned-hero-card__body">
        <h3 className="pinned-hero-card__title">{title}</h3>
        {badges && <div className="pinned-hero-card__badges">{badges}</div>}
        {extra && <div className="pinned-hero-card__extra">{extra}</div>}
        {meta && <div className="pinned-hero-card__meta">{meta}</div>}
      </div>

      {shouldRenderActions && (
        <div className={actionsClassName}>{actions}</div>
      )}
    </article>
  );
}
